import { useEffect } from 'react';

import { TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { MinusCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import useSnackbar from 'src/hooks/useSnackbar';

const TrlKeys = {
    text: 'career-platform.profession.sections.statistic.empty-state-snack.text',
};

const EmptyStateSnack: TranslatedComponent = ({ trls }) => {
    const { vacancies, salary, detail } = useSelectorNonNullable((state) => state.pageProfession.statistic);
    const { showSnack, hideSnack } = useSnackbar();

    useEffect(() => {
        const isEmptyDetailChart = detail.values.every(({ count }) => !count);
        const isAllGraphsEmpty = [!vacancies.initValue, !salary.initValue, isEmptyDetailChart].every(Boolean);

        if (isAllGraphsEmpty) {
            showSnack({
                children: trls[TrlKeys.text],
                addon: <MinusCircleFilledSize24 initial="negative" />,
                onClose: hideSnack,
                showClose: true,
                autohideTime: 0,
            });
        } else {
            hideSnack();
        }
    }, [detail, salary, vacancies, showSnack, hideSnack, trls]);

    return null;
};

export default translation(EmptyStateSnack);
